import get from 'lodash/get'
import * as httpStatusCodes from 'http-status-codes'

import fetchEntitlements from '../../../../service/entitlement/fetch-entitlements/fetchEntitlements'
import { setEntitlements } from '../../../../state/actions/entitlement/entitlement'
import { showDialog } from '../../../../state/actions/ui/ui'

const fetchAndSetEntitlements = async (dispatch: Function): Promise<void> => {
  try {
    const response = await fetchEntitlements()

    if (get(response, 'status') === httpStatusCodes.OK && response.data) {
      const entitlements = response.data

      dispatch(setEntitlements(entitlements))
    } else {
      dispatch(
        showDialog({
          title: 'Er ging iets mis',
          content: 'Onverwachte serverreactie ontvangen.',
        }),
      )
    }
  } catch (error) {
    dispatch(
      showDialog({
        title: 'Er ging iets mis',
        content: 'Producten ophalen mislukt. Probeer het later opnieuw.',
      }),
    )
  }
}

export default fetchAndSetEntitlements
